module.exports = __webpack_public_path__ + "static/media/dark-submenu-painel.66bccc8d.svg";